import { render, staticRenderFns } from "./lrTenantName.vue?vue&type=template&id=0f0fdb86&"
import script from "./lrTenantName.vue?vue&type=script&lang=js&"
export * from "./lrTenantName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports